import { AnalyticsSummary } from 'Src/analytics';
import Cookies from 'js-cookie';

/**
 * Normalizes the referrer for analytics purposes.
 *
 * If the referrer is empty, invalid, or matches the current domain,
 * returns `'UNKNOWN'`. Otherwise, returns the referrer URL as a string.
 *
 * @returns {string} The referrer URL or `'UNKNOWN'` if referrer is unavailable or is same as current domain.
 */
export function getNormalizedReferrer(referrer?: string): string {
  if (!referrer) {
    return 'UNKNOWN';
  }

  try {
    const currentDomain = window.location.hostname;
    const referrerUrl = new URL(referrer);

    if (referrerUrl.hostname === currentDomain) {
      return 'UNKNOWN';
    }

    return referrer;
  } catch {
    return 'UNKNOWN';
  }
}

export function sendAdminAnalyticsReport(
  eventName: string,
  report: AnalyticsSummary
) {
  if (!window._admin_logging) {
    window._admin_logging = [];
  }

  const trackingSummaryObject = {
    eventName,
    time: Date.now(),
    ...report
  };

  window._admin_logging.push(trackingSummaryObject);
  window.dispatchEvent(
    new CustomEvent('admin_tracking_debug_call', {
      detail: trackingSummaryObject
    })
  );
}

export function isHammerheadEnvironment() {
  return window && window['%hammerhead%'];
}

export function shouldDebugAnalyticsProviders() {
  return Boolean(Cookies.get('debug_analytics'));
}

export function isAdminEnabled() {
  return window.admin && window.admin?.isEditorActive();
}
